import DTO from './DTO';

class CommandTemplateDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: [],
        labelKey: 'id',
      },
      {
        name: 'name',
        type: String,
        validators: [],
        labelKey: 'name',
      },
      {
        name: 'expiration_interval',
        type: String,
        validators: [],
        labelKey: 'expiration_interval',
      },
      {
        name: 'is_lockable',
        type: Boolean,
        validators: [],
        labelKey: 'is_lockable',
      },
    ];
    super(attributes, params, isValidInit);
  }
}

export default CommandTemplateDTO;
